export enum FieldType {
  Metric = 'metric', // for render values that are metrics, sometimes required calculation
  Scalar = 'scalar', // for render pure values, like "number" or "string", usually from backend
  Media = 'media', // for render media content, like images
  HtmlMarkup = 'HtmlMarkup', // for render html markup
  Custom = 'custom', // for render custom layout
}

export const TYPE_METRIC = FieldType.Metric;
export const TYPE_SCALAR = FieldType.Scalar;
export const TYPE_MEDIA = FieldType.Media;
export const TYPE_CUSTOM = FieldType.Custom;
export const TYPE_HTML_MARKUP = FieldType.HtmlMarkup;
